import React from "react";

import { Text, Flex, Box, ButtonV1 } from "@edricphan2022/uikit";
import Container from "../../components/Container";
import HeaderOrbit from "../../components/HeaderOrbit";
import TabActive from "../../components/TabActive";
import ContentHeader from "../../components/ContentHeader";
import Circle from "../../components/Animations/Cricle";
import Square from "../../components/Animations/Square";
import Rhombus from "../../components/Animations/Rhombus";
import UncerTainIcons from "../../components/Animations/UncerTainIcon";
import TwoCircles from "../../components/Animations/TwoCircles";
import { useScrollToElement } from "../../components/ScrollElement";
import {
  Wrapper,
  CollapseStyle,
  ServicesTop,
  ServicesDesignAnd,
  BoxScroll,
  OurProcess,
  IndustryExpertise,
} from "./styled";
import { ArrScrollService } from "./config";
import OurProcessss from "./OurProcess";
import IndustryExpertises from "./IndustryExpertise";

import { useMatchBreakpoints } from "@edricphan2022/uikit";

const ServicesOrbit = () => {
  const { isTabletS } = useMatchBreakpoints();

  const elementNames = ArrScrollService.map((icon) => icon.name);

  const { getScrollToElementRef, scrollToElementClickHandler } = useScrollToElement(elementNames);
  return (
    <Wrapper>
      <CollapseStyle>
        <HeaderOrbit />
        <ServicesTop>
          <Container>
            <TabActive />
            <Flex justifyContent="center" pt="40px" pb='60px'>
              <Text maxWidth="504px" textAlign="center" fontSize="20px">
              Do your own Website  easily with Obit
              </Text>
            </Flex>
          </Container>
        </ServicesTop>
      </CollapseStyle>
      <ServicesDesignAnd>
        <Container>
          <Box className="ps-orbit">
            {isTabletS ? (
              <BoxScroll className="ps-services">
                <Box className="cus-tablet">
                  {elementNames.map((elementName, index) => {
                    return (
                      <ButtonV1
                        className="cus-button"
                        key={index}
                        onClick={() => scrollToElementClickHandler(elementName)}
                      >
                        {elementName}
                      </ButtonV1>
                    );
                  })}
                </Box>
                <Box className="cus-animated">
                  <ButtonV1 className="cus-button-tablet bt-orbit-1" variant="secondary">
                    <Circle width="70px" height="70px" />
                  </ButtonV1>
                  <ButtonV1 className="cus-button-tablet bt-orbit-2" variant="secondary">
                    <Square width="70px" height="70px" />
                  </ButtonV1>
                  <ButtonV1 className="cus-button-tablet bt-orbit-3" variant="secondary">
                    <Rhombus widthGroup="70px" heightGroup="70px" widthFloor="70px" heightFloor="70px" />
                  </ButtonV1>
                  <ButtonV1 className="cus-button-tablet bt-orbit-4" variant="secondary">
                    <UncerTainIcons width="70px" />
                  </ButtonV1>
                </Box>
              </BoxScroll>
            ) : (
              <BoxScroll>
                <Box className="name-posi">
                  {elementNames.map((elementName, index) => {
                    return (
                      <ButtonV1
                        className="cus-button"
                        key={index}
                        onClick={() => scrollToElementClickHandler(elementName)}
                      >
                        {elementName}
                      </ButtonV1>
                    );
                  })}
                </Box>
                <ButtonV1 variant="secondary">
                  <Circle width="94px" height="94px" />
                </ButtonV1>
                <ButtonV1 variant="secondary">
                  <Square width="94px" height="94px" />
                </ButtonV1>
                <ButtonV1 variant="secondary">
                  <Rhombus widthGroup="94px" heightGroup="94px" widthFloor="94px" heightFloor="94px" />
                </ButtonV1>
                <ButtonV1 variant="secondary">
                  <UncerTainIcons width="94px" />
                </ButtonV1>
              </BoxScroll>
            )}
          </Box>
          <Box pt="48px">
            <ContentHeader className="content-about" text="" title={`Website Design And Development Service`} />
          </Box>
        </Container>
      </ServicesDesignAnd>
      <OurProcess>
        <Container>
          <OurProcessss getScrollToElementRef={getScrollToElementRef} ArrScrollService={ArrScrollService} />
        </Container>
      </OurProcess>
    </Wrapper>
  );
};

export default ServicesOrbit;
